import { X } from "@phosphor-icons/react";

export function Modal({ open, onClose, title, children, testid }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/60 p-4 md:p-10" data-testid={testid}>
      <div className="w-full max-w-lg border border-[#2C2C2A] bg-[#1A1A18] shadow-2xl cm-fade-in">
        <div className="flex items-center justify-between border-b border-[#2C2C2A] px-6 py-4">
          <h3 className="font-display text-lg">{title}</h3>
          <button onClick={onClose} className="text-[#A1A19D] hover:text-[#F9F9F8]" data-testid="modal-close">
            <X size={18} />
          </button>
        </div>
        <div className="px-6 py-5">{children}</div>
      </div>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <div className="mb-4">
      <label className="cm-label">{label}</label>
      <div className="mt-1">{children}</div>
    </div>
  );
}

export const inputCls =
  "w-full rounded-sm border border-[#2C2C2A] bg-[#121211] px-3 py-2 text-sm text-[#F9F9F8] focus:outline-none focus:ring-2 focus:ring-[#F59E0B]";

export function PrimaryButton({ children, ...props }) {
  return (
    <button
      {...props}
      className="rounded-sm bg-[#F59E0B] px-4 py-2 text-sm font-semibold text-[#121211] transition-colors hover:bg-[#e8940a] disabled:opacity-60"
    >
      {children}
    </button>
  );
}

export function GhostButton({ children, ...props }) {
  return (
    <button
      {...props}
      className="rounded-sm border border-[#2C2C2A] bg-[#1A1A18] px-4 py-2 text-sm text-[#F9F9F8] transition-colors hover:bg-[#242422] disabled:opacity-60"
    >
      {children}
    </button>
  );
}
